import type { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { SBHorizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Bold } from '#src/atoms/typography/Bold/index.tsx';
import { BodyM, HeadlineM } from '#src/atoms/typography/index.tsx';

type Description = MessageDescriptor | MessageDescriptor[];

export type Props = {
  title?: MessageDescriptor;
  description?: Description;
  toggleButton?: ReactNode;
};

const SingleDescription = ({
  description,
}: {
  description: MessageDescriptor;
}) => (
  <BodyM color="var(--c-onBase-secondary)">
    <FormattedMessage {...description} values={{ bold: Bold }} />
  </BodyM>
);

const DescriptionDisplayer = ({
  description,
}: {
  description: Description;
}) => {
  if (Array.isArray(description)) {
    return (
      <>
        {description.map(d => {
          return <SingleDescription key={d.id} description={d} />;
        })}
      </>
    );
  }
  return <SingleDescription description={description} />;
};

export const Header = ({ description, title, toggleButton }: Props) => (
  <>
    {!!(description || title) && (
      <SBHorizontal>
        <Vertical>
          {!!title && (
            <div className="flex items-start justify-between">
              <HeadlineM as="h4">
                <FormattedMessage {...title} />
              </HeadlineM>
            </div>
          )}
          {!!description && <DescriptionDisplayer description={description} />}
        </Vertical>
        {!!toggleButton && <div>{toggleButton}</div>}
      </SBHorizontal>
    )}
  </>
);
